import React, { useState, useEffect } from 'react';
import { Swords, Trophy, Flame, MapPin, TrendingUp } from 'lucide-react';
import { apiClient } from '../../api/client';

const TeenChallengeView = ({ teenId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.request(`/api/meetups/parent/teen-challenges/${teenId}`)
      .then(setData)
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [teenId]);

  if (loading) return <div className="p-4 bg-gray-50 rounded-xl text-sm text-gray-400">Loading challenge data...</div>;
  if (!data) return null;

  return (
    <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl p-4 sm:p-5 border border-indigo-200" data-testid="teen-challenge-view">
      <div className="flex items-center gap-2 mb-4">
        <Swords size={20} className="text-indigo-600" />
        <h3 className="text-sm font-bold text-gray-900">{data.teen_name}&apos;s Social Challenges</h3>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
        <div className="bg-white/70 rounded-lg p-3 text-center">
          <p className="text-lg font-black text-indigo-600">{data.this_week?.active_challenges || 0}</p>
          <p className="text-[10px] text-gray-500 uppercase tracking-wider">Active This Week</p>
        </div>
        <div className="bg-white/70 rounded-lg p-3 text-center">
          <p className="text-lg font-black text-green-600">{data.this_week?.completed_challenges || 0}</p>
          <p className="text-[10px] text-gray-500 uppercase tracking-wider">Completed This Week</p>
        </div>
        <div className="bg-white/70 rounded-lg p-3 text-center">
          <p className="text-lg font-black text-purple-600">{data.this_month?.completed_challenges || 0}</p>
          <p className="text-[10px] text-gray-500 uppercase tracking-wider">This Month</p>
        </div>
        <div className="bg-white/70 rounded-lg p-3 text-center">
          <p className="text-lg font-black text-amber-600">{data.all_time?.completed_challenges || 0}</p>
          <p className="text-[10px] text-gray-500 uppercase tracking-wider">All Time</p>
        </div>
      </div>

      <div className="flex flex-wrap gap-3">
        {data.challenge_streak > 0 && (
          <div className="flex items-center gap-1.5 px-3 py-1.5 bg-white/70 rounded-full">
            <Flame size={14} className="text-orange-500" />
            <span className="text-xs font-semibold text-gray-700">{data.challenge_streak}-week streak</span>
          </div>
        )}
        {data.upcoming_meetups > 0 && (
          <div className="flex items-center gap-1.5 px-3 py-1.5 bg-white/70 rounded-full">
            <MapPin size={14} className="text-teal-500" />
            <span className="text-xs font-semibold text-gray-700">{data.upcoming_meetups} upcoming meetup{data.upcoming_meetups > 1 ? 's' : ''}</span>
          </div>
        )}
        {data.all_time?.completed_challenges > 0 && (
          <div className="flex items-center gap-1.5 px-3 py-1.5 bg-white/70 rounded-full">
            <TrendingUp size={14} className="text-green-500" />
            <span className="text-xs font-semibold text-gray-700">Growing socially</span>
          </div>
        )}
      </div>

      <p className="text-[10px] text-gray-400 mt-3 italic">Challenge participation shown — conversation details remain private</p>
    </div>
  );
};

export default TeenChallengeView;
